module.exports = __webpack_public_path__ + "static/img/orders-1x.83e8b06.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/orders-1x.png
// module id = tMEI
// module chunks = 53